.backdrop {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: grid;
  place-items: center;
  padding: var(--hs-spacing-4);
  background: rgb(21 25 30 / 0.45);
}
.panel {
  display: flex;
  flex-direction: column;
  gap: var(--hs-spacing-3);
  width: min(100%, 28rem);
  padding: var(--hs-spacing-6);
  border-radius: var(--hs-radius-lg);
  background: var(--hs-color-bg-surface);
  box-shadow: var(--hs-shadow-xl);
  color: var(--hs-color-text-primary);
}
.title {
  margin: 0;
  font: var(--hs-type-h3);
}
.text {
  color: var(--hs-color-text-secondary);
  font: var(--hs-type-body);
}
.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--hs-spacing-2);
  margin-top: var(--hs-spacing-2);
}
.destructive {
  background: var(--hs-color-danger-default);
  color: var(--hs-color-text-on-primary);
}
